import { HttpEventType, HttpResponse } from "@angular/common/http";
import {
  ChangeDetectorRef,
  Component,
  OnInit,
  OnChanges,
  SimpleChanges,
  Input,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ConfirmationService, MessageService } from "primeng/api";
import { StartupUploadService } from "src/app/services/startup_upload.service";
import { environment } from "src/environments/environment";
import { CommonModule } from "@angular/common";
import { FileUploadModule } from "primeng/fileupload";
import { ButtonModule } from "primeng/button";
import { ImageModule } from "primeng/image";
import { ToastModule } from "primeng/toast";
import { ConfirmDialogModule } from "primeng/confirmdialog";

@Component({
  standalone: true,
  selector: "app-upload-single",
  templateUrl: "./upload-single.component.html",
  imports: [
    CommonModule,
    FileUploadModule,
    ButtonModule,
    ImageModule,
    ToastModule,
    ConfirmDialogModule,
  ],
})
export class UploadSingleComponent implements OnInit, OnChanges {
  @Input() element: any = {};

  @ViewChild("myInput", { static: false }) myInputVariable: ElementRef;
  imageInfos: any;
  error: string;
  selectedFiles?: FileList;
  progressInfos: any[] = [];
  message: string[] = [];
  previews: string[] = [];
  uploadError: string;
  imagePath: any;
  path = environment.logo_url;

  constructor(
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private startupUploadService: StartupUploadService,
    private cdr: ChangeDetectorRef,
  ) {}

  public ngOnInit(): void {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes["element"] && this.element) {
      this.loadImages();
    }
  }

  private loadImages(): void {
    this.startupUploadService.getId(this.element).subscribe((res) => {
      this.imageInfos = res;
      this.cdr.detectChanges();
    });
  }

  selectFiles(event: any): void {
    this.message = [];
    this.progressInfos = [];
    this.selectedFiles = event.target.files;
    this.previews = [];

    if (this.selectedFiles && this.selectedFiles[0]) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const reader = new FileReader();
        reader.onload = (e: any) => this.previews.push(e.target.result);
        reader.readAsDataURL(this.selectedFiles[i]);
      }
    }
  }

  onDeleteImage(image_id: any, image_name: any, page_id: any): void {
    this.confirmationService.confirm({
      message: "Sei sicuro di volerlo cancellare = " + image_name,
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => {
        this.startupUploadService.delete_image(+image_id, +page_id).subscribe(
          () => {
            this.messageService.add({
              key: "myKeyUpload",
              severity: "success",
              summary: "Attenzione",
              detail: "Cancellazione avvenuto con successo",
            });
            this.loadImages();
          },
          (error) => (this.error = error),
        );
      },
    });
  }

  upload(idx: number, file: File): void {
    this.progressInfos[idx] = { value: 0, fileName: file.name };

    if (file) {
      this.startupUploadService.upload(file, this.element).subscribe({
        next: (event: any) => {
          if (event.type === HttpEventType.UploadProgress) {
            this.progressInfos[idx].value = Math.round(
              (100 * event.loaded) / event.total,
            );
          } else if (event instanceof HttpResponse) {
            this.message.push("Uploaded the file successfully: " + file.name);
            this.loadImages();
            this.previews = [];
            this.progressInfos = [];
            setTimeout(() => (this.message = []), 1500);
          }
        },
        error: () => {
          this.progressInfos[idx].value = 0;
          this.message.push("Could not upload the file: " + file.name);
        },
      });
    }
    this.selectedFiles = null;
  }

  uploadFiles(): void {
    this.message = [];
    if (this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        this.upload(i, this.selectedFiles[i]);
      }
    }
  }

  removeImageFile(): void {
    this.imagePath = "";
    this.myInputVariable.nativeElement.value = "";
  }
}
